import { addDays, eachDayOfInterval, format, parseISO } from "date-fns";
import React, { useCallback } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { TitleHeader } from "../../Common/Components/TitleHeader";
import useCartTotal from "../../Common/Hooks/useCartTotal";
import useTax from "../../Common/Hooks/useTax";
import { fetchServices } from "../../Services/CartService";
import { fetchTimeSlot, isDateBetween } from "../../Services/MainService";
import { fetchCoupon, fetchWeekDaysOff } from "../../Services/OrderService";
import { AddressPicker } from "../Components/AddressPicker";
import { DatePicker } from "../../Common/Components/DatePicker";
import LoginWarning from "../Components/LoginWarning";
import OrderSummaryItems from "../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../Common/Components/SummaryTotalPriceCard";
import OrderNotesPicker from "../../Common/Components/OrderNotesPicker";

export const Summary = () => {
  const loggedIn = useSelector((x) => x.LoggedIn);
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const bookingType = useSelector((x) => x.BookingType);
  const cart = useSelector((x) => x.Cart);
  const coupon = useSelector((x) => x.Coupon);
  const pickupDate = useSelector((x) => x.PickupDate);
  const deliveryDate = useSelector((x) => x.DeliveryDate);
  const zone = useSelector((x) => x.Zone);
  const note = useSelector((x) => x.Note);
  const addresses = useSelector((x) => x.Addresses);
  const apiNotes = useSelector((x) => x.Customer?.customer_note) || [];
  // const initialAddress = useSelector((x) => x.Address)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [pickupLoading, setPickupLoading] = React.useState(false);
  const [deliveryLoading, setDeliveryLoading] = React.useState(false);
  const [deliveryType, setDeliveryType] = React.useState(null);
  const [showPickup, setShowPickup] = React.useState(false);
  const [showDelivery, setShowDelivery] = React.useState(false);
  const [pickupRange, setPickupRange] = React.useState([]);
  const [sPickup, setSPickup] = React.useState(null);
  const [sPSlot, setSPSlot] = React.useState(null);
  const [deliveryRange, setDeliveryRange] = React.useState([]);
  const [sDelivery, setSDelivery] = React.useState(null);
  const [sDSlot, setSDSlot] = React.useState(null);
  const [cLoading, setCLoading] = React.useState(false);
  const [code, setCode] = React.useState(coupon?.coupon?.code ?? "");
  const [addressModal, setAddressModal] = React.useState(null);
  const [address, setAddress] = React.useState({
    pickup: null,
    delivery: null,
  });
  const [items, setItems] = React.useState([]);
  const [services, setServices] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const [tAddress, setTAddress] = React.useState(null);
  const [weekDaysOff, setWeekDaysOff] = React.useState(null);
  const [open, setOpen] = React.useState({});
  const [showWarning, setShowWarning] = React.useState(false);
  const [subtotal, tax, discount, deliveryCharge, total, grossTotal] =
    useTax(deliveryType);

  const setNote = (e) => {
    dispatch({ type: "setNote", payload: e });
  };

  const HandlePickupChange = (e) => {
    setSPickup(e.date);
    setSPSlot(e.slot);
    dispatch({ type: "setPickupDate", payload: e });
    setShowPickup(false);
  };
  const HandleDeliveryChange = useCallback(
    (e) => {
      setSDelivery(e.date);
      setSDSlot(e.slot);
      dispatch({ type: "setDeliveryDate", payload: e });
      setShowDelivery(false);
    },
    [dispatch]
  );
  const checkCoupon = () => {
    if (loggedIn) {
      if (coupon) {
        dispatch({ type: "setCoupon", payload: null });
        setCode("");
      } else if (code.trim() !== "" && !cLoading) {
        setCLoading(true);
        fetchCoupon({
          code,
          amount: grossTotal,
          zone_id: zone,
        }).then(
          (res) => {
            setCLoading(false);
            // console.log(res);
            dispatch({ type: "setCoupon", payload: res });
          },
          (err) => {
            setCLoading(false);
            err?.errors?.forEach((er) => {
              toast.error(er.message);
            });
          }
        );
      }
    } else setShowWarning(true);
  };
  const HandleAddressChange = (e) => {
    // debugger;
    if (e.laundry_zone_id == zone) {
      if (addressModal === "pickup") {
        setAddress((v) => ({ ...v, pickup: e }));
      } else {
        setAddress((v) => ({ ...v, delivery: e }));
      }
      setAddressModal(null);
    } else {
      setTAddress(e);
    }
  };
  const ReplaceAddress = (e) => {
    if (addressModal === "pickup") {
      setAddress((v) => ({ pickup: e, delivery: null }));
    } else {
      setAddress((v) => ({ pickup: null, delivery: e }));
    }
    setAddressModal(null);
    setTAddress(null);

    dispatch({ type: "setZone", payload: e.laundry_zone_id });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });

    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
  };
  const FilterRange = useCallback(
    (range) => {
      return range.filter((date) => {
        const day = format(date, "EEEE").toLowerCase();
        const dateStringFormatted = format(date, "yyyy-MM-dd");

        return (
          !weekDaysOff?.weekdaysOff.includes(day) &&
          !weekDaysOff?.offDays.includes(dateStringFormatted)
        );
      });
    },
    [weekDaysOff]
  );

  React.useEffect(() => {
    setLoading(true);
    if (cart && cart.length > 0) {
      setDeliveryType(deliveryTypes.find((x) => x.id == orderTypeId));
    } else navigate("/app", { replace: true });
  }, [cart, deliveryTypes, navigate, orderTypeId]);
  React.useEffect(() => {
    setPickupLoading(true);
    if (weekDaysOff) {
      if (deliveryType) {
        // console.log(deliveryType);
        var sd = addDays(new Date(), deliveryType?.pickup_duration);
        const ed = addDays(sd, (deliveryType?.noOf_calender_dates || 15) - 1);
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        if (pickupDate?.date && pickupDate?.slot) {
          fetchTimeSlot(
            format(pickupDate?.date, "yyyy-MM-dd"),
            1,
            bookingType
          ).then(
            (res) => {
              const sl = res.findIndex((x) => x.id === pickupDate.slot.id);
              if (~sl) {
                setSPickup(pickupDate?.date);
                setSPSlot(pickupDate?.slot);
              } else {
                dispatch({ type: "setPickupDate", payload: null });
                toast.warn(
                  "Pickup Time slot you selected last time is not available now please select another slot!"
                );
              }
              setPickupLoading(false);
            },
            (er) => {
              // console.warn(er, "error on slot");
              toast.error("Something went wrong while fetching Time Slots.");
            }
          );
        } else setPickupLoading(false);
        // if (pickupDate?.date) {
        //   setSPickup(pickupDate?.date);
        // }
        // if (pickupDate?.slot) {
        //   setSPSlot(pickupDate?.slot);
        // }
        setPickupRange(dif);
      }
    }
  }, [
    pickupDate,
    weekDaysOff,
    deliveryType,
    bookingType,
    FilterRange,
    dispatch,
  ]);
  React.useEffect(() => {
    if (weekDaysOff) {
      if (pickupDate && deliveryType) {
        let skip = deliveryType?.duration;
        if (orderTypeId != 1 && orderTypeId != 2) {
          const serv = services.find((x) => x.id == items[0]?.services_id);
          console.log(serv);
          if (serv)
            skip =
              bookingType == 1 ? serv.regular_duration : serv.express_duration;
        }

        const sd = addDays(pickupDate.date, skip);
        const ed = addDays(sd, (deliveryType?.noOf_calender_dates || 15) - 1);
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        setDeliveryRange(dif);
        if (deliveryDate?.date) {
          const ld =
            typeof deliveryDate.date == "string"
              ? parseISO(deliveryDate.date)
              : deliveryDate.date;
          if (!isDateBetween(ld, sd, ed)) {
            dispatch({ type: "setDeliveryDate", payload: null });
          } else if (deliveryDate.slot) {
            setDeliveryLoading(true);
            fetchTimeSlot(
              format(ld, "yyyy-MM-dd"),
              2,
              bookingType,
              pickupDate.slot?.id,
              format(pickupDate.date, "yyyy-MM-dd")
            ).then(
              (res) => {
                const sl = res.findIndex((x) => x.id === deliveryDate?.slot.id);
                if (~sl) {
                  setSDelivery(ld);
                  setSDSlot(deliveryDate?.slot);
                } else {
                  dispatch({ type: "setDeliveryDate", payload: null });
                  toast.warn(
                    "Delivery Time slot you selected last time is not available now please select another slot!"
                  );
                }
                setDeliveryLoading(false);
              },
              (er) => {
                // console.warn(er, "error on slot");
                toast.error("Something went wrong while fetching Time Slots.");
              }
            );
          }
        } else {
          if (!deliveryDate || !deliveryDate?.slot) {
            const pr = async () => {
              setDeliveryLoading(true);
              for (let i = 0; i < dif.length; i++) {
                const d = dif[i];
                try {
                  const res = await fetchTimeSlot(
                    format(deliveryDate?.date || d, "yyyy-MM-dd"),
                    2,
                    bookingType,
                    pickupDate.slot?.id,
                    format(pickupDate.date, "yyyy-MM-dd")
                  );
                  if (res.length > 0) {
                    HandleDeliveryChange({
                      date: deliveryDate?.date || d,
                      slot: res[0],
                    });
                    break;
                  }
                } catch (er) {
                  console.warn(er, "error on slot");
                  toast.error(
                    "Something went wrong while fetching Time Slots."
                  );
                }
              }
              setDeliveryLoading(false);
            };
            pr();
          }
        }
      }
    }
  }, [
    pickupDate,
    deliveryType,
    bookingType,
    deliveryDate,
    weekDaysOff,
    orderTypeId,
    items,
    services,
    FilterRange,
    dispatch,
    HandleDeliveryChange,
  ]);
  React.useEffect(() => {
    if (address.delivery || address.pickup) {
      dispatch({ type: "setAddresses", payload: address });
    }
  }, [address]);
  React.useEffect(() => {
    if (!loaded) {
      if (addresses) {
        setAddress(addresses);
      }
      setLoaded(true);
    }
  }, [addresses, loaded]);
//   React.useEffect(() => {
//   if (!loaded && initialAddress) {
//     setAddress({
//       pickup: initialAddress,
//       delivery: initialAddress,
//     });
//     setLoaded(true);
//   }
// }, [initialAddress, loaded]);
  React.useEffect(() => {
    if (deliveryType)
      fetchWeekDaysOff(deliveryType?.id).then(
        (res) => setWeekDaysOff(res),
        () => toast.error("Something went wrong!")
      );
  }, [deliveryType]);

  React.useEffect(() => {
    setLoading(true);
    setDeliveryType(deliveryTypes.find((x) => x.id == orderTypeId));
    fetchServices(100, 1, orderTypeId).then(
      (res) => {
        setServices(res);
      },
      (err) => console.warn(err, "err while fetching services...")
    );
  }, [deliveryTypes, orderTypeId]);
  React.useEffect(() => {
    if (services.length !== 0 && cart.length !== 0) {
      setLoading(true);
      const temp = cart.reduce((result, item) => {
        const key = item.serviceId;
        setOpen((prev) => ({
          ...prev,
          [key]: true,
        }));
        if (!result[key]) {
          result[key] = {
            services_id: key,
            service: services.find((s) => s.id === key)?.name,
            open: true,
            items: [],
          };
        }
        const {
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          is_bundle_active,
          bundle_free,
          free_items,
          bundle_buy,
          item_note,
        } = item;
        result[key].items.push({
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          free_items,
          bundle_free,
          bundle_buy,
          is_bundle_active,
          item_note,
        });
        return result;
      }, {});
      const tempTemp = Object.values(temp);
      const anotherTemp = [];
      for (let i = 0; i < tempTemp.length; i++) {
        const x = tempTemp[i];
        anotherTemp.push(x);
      }
      setItems(anotherTemp);
      setLoading(false);
    }
  }, [cart, services]);
  
  return (
    <>
      <TitleHeader
        title={"Order Summary"}
        subtitle={
          "Review your order details and get ready for a fresh, clean wardrobe!"
        }
      />
      <div className="container">
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            {/* Pricing Details */}
            {loading ? null : (
              <OrderSummaryItems items={items} open={open} setOpen={setOpen} />
            )}
            <div className="card  mb-3">
              {loading ? (
                <div className="w-100 text-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  <TotalPriceCard deliveryType={deliveryType} />
                </>
              )}
            </div>
            {/* Coupon */}
            <div className="card mb-3">
              <div className="card-body">
                <span className="fw-semibold mb-3 d-block">Apply Coupon</span>
                <div className="input-group" style={{ height: "44px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Coupon Code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                  <button
                    className={`btn text-white fw-semibold ${
                      coupon ? "btn-danger" : "btn-primary"
                    }`}
                    type="button"
                    onClick={() => checkCoupon()}
                    disabled={cLoading}
                  >
                    {cLoading ? (
                      <Spinner variant="white" size="sm" />
                    ) : coupon ? (
                      "Remove"
                    ) : (
                      "Apply"
                    )}
                  </button>
                </div>
              </div>
            </div>
            {/* Address */}
            <div className="card mb-3">
              <div className="card-body">
                <span className="fw-semibold mb-3 d-block">Address</span>
                <div
                  className="row cursor-pointer"
                  onClick={() => {
                    if (loggedIn) setAddressModal("pickup");
                    else setShowWarning(true);
                  }}
                >
                  <div className="col-1 text-end pe-0">
                    <i
                      className="fa-solid fa-circle-dot"
                      style={{ color: "#32b6e9" }}
                    ></i>
                  </div>
                  <div className="col-11">
                    <h6 className="mb-1">Pickup Address</h6>
                    <p className="m-0">
                      {address.pickup
                        ? `${address.pickup?.address1}, ${address.pickup?.address2}, ${address.pickup?.area?.[0]?.name}, ${address.pickup?.phase?.[0]?.name}`
                        : "Select address"}
                    </p>
                    <hr style={{ borderStyle: "doted" }} />
                  </div>
                </div>

                <div
                  className="row cursor-pointer"
                  onClick={() => {
                    if (loggedIn) setAddressModal("delivery");
                    else setShowWarning(true);
                  }}
                >
                  <div className="col-1 text-end pe-0">
                    <i
                      className="fa-solid fa-location-dot text-primary"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                  <div className="col-11">
                    <h6 className="mb-1">Delivery Address</h6>
                    <p className="m-0">
                      {address.delivery
                        ? `${address.delivery?.address1}, ${address.delivery?.address2}, ${address.delivery?.area?.[0]?.name}, ${address.delivery?.phase?.[0]?.name}`
                        : "Select address"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Date pickers */}
            <div className="card mb-3">
              {!pickupLoading && !deliveryLoading ? (
                <div className="card-body">
                  <span className="fw-semibold mb-3 d-block">
                    Schedule Dates
                  </span>

                  <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
                    <div className="col-12 col-md-5 px-4">
                      <small
                        style={{ position: "absolute", top: "-12px" }}
                        className="bg-white px-2"
                      >
                        Pickup
                      </small>
                      <div
                        className="d-flex align-items-center py-3 border-r border-gray cursor-pointer"
                        onClick={() => setShowPickup(true)}
                      >
                        <i
                          className="fa-regular fa-calendar-plus me-3"
                          style={{ fontSize: "22px", color: "#666" }}
                        ></i>
                        {sPickup ? format(sPickup, "eee, do MMM") : "Date"}
                        {sPSlot && sPickup ? <br /> : "/"}
                        {sPSlot
                          ? `${sPSlot?.start_time} - ${sPSlot?.end_time}`
                          : "Time"}
                      </div>
                    </div>
                    <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                      &nbsp;
                    </div>
                    <hr className="w-100 my-2 d-block d-md-none" />
                    <div className="col-12 col-md-5 px-4">
                      <small
                        style={{ position: "absolute" }}
                        className={`bg-white px-2 app-dates-delivery-label ${
                          !sPickup && !sPSlot ? "alt" : ""
                        }`}
                      >
                        Delivery
                      </small>
                      <div
                        className="d-flex align-items-center py-3 cursor-pointer"
                        onClick={() => {
                          if (sPickup && sPSlot) setShowDelivery(true);
                          else
                            toast.error(
                              "Please select pickup date & slot first..."
                            );
                        }}
                      >
                        <i
                          className="fa-regular fa-calendar-plus me-3"
                          style={{ fontSize: "22px", color: "#666" }}
                        ></i>
                        {sDelivery ? format(sDelivery, "eee, do MMM") : "Date"}
                        {sDSlot && sDelivery ? <br /> : "/"}
                        {sDSlot
                          ? `${sDSlot?.start_time} - ${sDSlot?.end_time}`
                          : "Time"}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-100 text-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
            {/* Note */}
             {/* <div className="card mb-3">
              <div className="card-body">
                <span className="fw-semibold mb-3 d-block">
                  Order Note / Instructions
                </span>
                <textarea
                  className="form-control"
                  rows="3"
                  value={note || ""}
                  onChange={(e) => setNote(e.target.value)}
                ></textarea>
              </div>
            </div> */}
            <div className="card mb-3">
              <div className="card-body">
                <OrderNotesPicker
                  apiNotes={apiNotes}          // dummy for now
                  value={note}                 // now this will be ARRAY
                  onChange={setNote}           // setNote will store array
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
            style={{ columnGap: "20px" }}
          >
            <div
              className="service-btn cart"
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </div>
            {/* { deliveryDate && pickupDate ? (
              <Link className="service-btn next" to="/order-review">
                Next
              </Link>
            ) : ( */}
            <button
              className="service-btn next"
              onClick={() => {
                if (!deliveryDate || !pickupDate) {
                  toast.error(
                    "Please select pickup & delivery dates to continue."
                  );
                  return;
                }
                if (!address.pickup || !address.delivery) {
                  toast.error(
                    "Please select pickup & delivery addresses to continue."
                  );
                  return;
                }
                if (
                  deliveryDate &&
                  pickupDate &&
                  address.pickup &&
                  address.delivery
                ) {
                  navigate("/app/order-review");
                }
              }}
            >
              Next
            </button>
            {/* )} */}
          </div>
        </div>
      </div>
      {/* Pickup date modal*/}
      <Modal
        show={showPickup}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowPickup(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPickup ? (
            <DatePicker
              range={pickupRange}
              selected={sPickup}
              onChange={HandlePickupChange}
              orderType={bookingType}
              timeSlot={sPSlot}
              type={1}
            />
          ) : null}
        </Modal.Body>
      </Modal>
      {/* delivery date modal*/}
      <Modal
        show={showDelivery}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowDelivery(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showDelivery ? (
            <DatePicker
              range={deliveryRange}
              selected={sDelivery}
              onChange={HandleDeliveryChange}
              orderType={bookingType}
              timeSlot={sDSlot}
              pickup={{
                date: sPickup ? format(sPickup, "yyyy-MM-dd") : null,
                slotId: sPSlot.id,
              }}
              type={2}
            />
          ) : null}
        </Modal.Body>
      </Modal>
      {/* Addresses modal*/}

      <AddressPicker
        show={Boolean(addressModal)}
        closeButton={true}
        onHide={() => setAddressModal(null)}
        title={` Select Your ${
          addressModal === "pickup" ? "Pickup " : "Delivery"
        } Address`}
        onSelect={HandleAddressChange}
        showDelete={false}
        showEdit={false}
      />
      <ConfirmationModal
        show={Boolean(tAddress)}
        text="The Address you selected is not in the same zone as you selected in start if you change your zone your cart will be empty. Are your sure you want to change your address?"
        onYes={() => ReplaceAddress(tAddress, true)}
        onNo={() => setTAddress(null)}
      />
      {!loggedIn && showWarning ? (
        <LoginWarning
          onCancel={() => setShowWarning(false)}
          cancelText="Cancel"
        />
      ) : null}
    </>
  );
};
